import { LitElement, html } from "lit-element";
import { until } from "lit-html/directives/until.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { image } from "../styles/icons.js";


class imageLoader {
	constructor() {
		this.request = Promise.resolve();
	}

	load(url) {

		this.request = this.request.then(r => {

			return fetch(url, {
				method: "get",
				headers: { Authorization: "Bearer " + localStorage.token }
			});
		})

			.then(res => {
				if (res.ok) {
					return res;
				}
				throw new Error(res.status + " " + res.statusText);
			})
			.then(res => res.json())
			.then(img => {
				const uint8Array = new Uint8Array(img.dataArray);
				return new Blob([uint8Array], { type: img.dataMimeType });
			})
			.then(blob => {
				if (blob.size > 0) {
					this.objectUrl = URL.createObjectURL(blob);
					return this.objectUrl;
				}
			})
			.catch(ex => ex);


		return this.request;
	}
}

let loader = new imageLoader();


class InspxAjaxImage extends LitElement {
	shouldUpdate() {
		return this.src != undefined;
	}

	render() {
		return html`
        ${SharedStyles}
            <style>
                :host {
                    position: relative;
                    height: 100%;
                    text-align: center;
                }

                .img {
                    height: var(--db-image-height, 200px);
                    min-height: 200px;
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center center;
                }

                .empty-icon {
                    display: flex;
                    justify-content: center;
                    align-content: center;
                    align-items: center;
                    height: 100%;
                }

                .empty-icon svg {
                    width: 50px;
                    height: 50px;
                    fill: var(--secondary-color-variant1);
                }
            </style>

            ${until(this.getImage(), this.getStabImage())}
        `;
	}

	static get properties() {
		return { src: { type: String } };
	}

	disconnectedCallback() {
		if (this.objectUrl) {
			URL.revokeObjectURL(this.objectUrl);
		}
	}

	getStabImage() {
		return html`<div class="empty-icon">${image}</div>`;
	}

	getImage() {
		if (this.src == undefined)
			return;

		return loader.load(this.src)
			.then(a => {
				if (a && a.message == "404 Not Found") {
					return this.getStabImage();
				} else {

					return html`<div class="img" style="background-image: url('${a}');"></div>`
				}
			})

	}
}

window.customElements.define("inspx-ajax-image", InspxAjaxImage);
